import { configs } from "configs";

export const getAppLanguage = () => {
  const pathDirectories = window.location.pathname.split("/").filter(Boolean);
  if (pathDirectories.length > 0) {
    const pathLocale = pathDirectories[0];
    const foundLanguage = configs.languages.find((e) => e.key === pathLocale);
    if (foundLanguage) {
      return foundLanguage;
    }
  }
  return configs.languages[0];
};
